var map = {
	"./mobile/orderDetails.vue": [
		"1803",
		"chunk-6c826fd1"
	],
	"./pc/orderDetails.vue": [
		"79a3",
		"chunk-3e1b9214",
		"chunk-c1506a50"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "34a4";
module.exports = webpackAsyncContext;